export function isPresent(obj: any) {
    return obj !== undefined && obj !== null;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/component/alps-loading-bar/utils.ts